export default __webpack_public_path__ + "static/media/home3@2x.70cdb310.png";